import { MessageEnum } from './models/message.enum';
import { Observable } from 'rxjs';

declare const Human: any;

export type Func<A, B> = (params: A) => B;

interface RPCContext {
  setResult: <T>(response: T) => void;
}

export interface Procedure<RPCRequest, RPCResponse> {
  procName: MessageEnum;
  actionFn: Func<RPCRequest, RPCResponse>;
  aliases?: MessageEnum[];
  mapFnIn?: Func<any, RPCRequest>;
  mapFnOut?: Func<any, RPCResponse>;
}

export function defineProcedure<RPCRequest, RPCResponse>(
  procedure: Procedure<RPCRequest, RPCResponse>
) {
  
  const { procName, actionFn, aliases = [], mapFnIn, mapFnOut } = procedure;

  const defineCallback = function(params: any) {
    const self: RPCContext = this;

    // map to model
    const procParam: RPCRequest = mapFnIn ? mapFnIn(params) : <RPCRequest>params;
    const procReturnValue: RPCResponse = actionFn(procParam);

    if (typeof procReturnValue === 'undefined') {
      return;
    }

    // publish result
    if (procReturnValue instanceof Observable) {
      const procReturnValue$: Observable<any> = procReturnValue;
      procReturnValue$.subscribe(value => {
        const out = mapFnOut ? mapFnOut(value) : value;
        self.setResult(out);
      });
    } else {
      const out = mapFnOut ? mapFnOut(procReturnValue) : procReturnValue;
      self.setResult(out);
    }
  };

  const procNames = [procName, ...aliases];
  procNames.forEach(_procName => Human.rpc.define(_procName, defineCallback));
}
